<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="جزییات مشتری" active>
          <b-alert :show="errors.length > 0" variant="danger">
            <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-card-text>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group id="example-input-group-1" label="انتخاب نقش:" label-for="example-input-1">
                  <b-form-select v-model="user.role_id" :options="loadedRoleList"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group id="example-input-group-1" label="توضیحات:" label-for="example-input-1">
                  <MDDropdown v-bind:group="119" v-model="user.mdid119_description"></MDDropdown>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="example-input-group-1" label="تاریخ ثبت نام:" label-for="example-input-1">
                  <b-form-input id="input-4" :disabled="true" v-model="user.created_at"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="example-input-group-1" label="نوع:" label-for="example-input-1">
                  <MDDropdown :disabled="false" v-bind:group="17" v-model="user.mdid17_merchant_type"></MDDropdown>
                  <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن نام اجباری است</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="example-input-group-1" label="وضعیت استعلام تلفن همراه و کد ملی:"
                  label-for="example-input-1">
                  <MDDropdown :disabled="false" v-bind:group="116" v-model="user.mdid116_status"></MDDropdown>
                </b-form-group>
              </b-col>
            </b-row>
            <div v-if="user.mdid17_merchant_type == 1550">
              <PersonInfo v-model="user" v-bind:disabled="false"></PersonInfo>
            </div>
            <div v-if="user.mdid17_merchant_type == 1551">
              <CompanyInfo v-model="user" v-bind:disabled="false"></CompanyInfo>
            </div>
            <h4>اطلاعات تماس</h4>
            <UserAddress v-model="user" v-bind:disabled="false"></UserAddress>
            <div>
              <b-row class="mt-3">
                <b-col>
                  <b-button v-if="user.mdid116_status != 1732" @click="InquiryNationalcard" variant="warning">استعلام
                    تلفن همراه و کد ملی</b-button>
                  &nbsp;
                  <b-button @click="SaveUser" variant="success"
                    :class="isBusy ? 'spinner spinner-light spinner-right' : ''">ذخیره</b-button>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab href="#userconfirm" :active="$route.hash === '#userconfirm'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#userconfirm'
          )
          " title="وضعیت تاییدیه ها">
          <b-card-text>
            <list-table :url="userconf.url" title="وضعیت تاییدیه ها" :detailUrl="userconf.detailUrl"
              :fields="userconf.fields" :params="userconf.params"></list-table>
          </b-card-text>
        </b-tab>
        <b-tab href="#usergateway" :active="$route.hash === '#usergateway'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#usergateway'
          )
          " title="درگاه ها">
          <b-card-text>
            <list-table :url="merchats.url" title="لیست درگاه ها" :detailUrl="merchats.detailUrl"
              :fields="merchats.fields" :params="merchats.params"></list-table>
          </b-card-text>
        </b-tab>
        <b-tab href="#userticket" :active="$route.hash === '#usertickety'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#userticket'
          )
          " title="تیکت ها">
          <b-card-text>
            <list-table :url="tickets.url" :newUrl="tickets.newUrl" title="لیست تیکت ها" :detailUrl="tickets.detailUrl"
              :fields="tickets.fields" :params="tickets.params"></list-table>
          </b-card-text>
        </b-tab>

        <b-tab href="#usergardesh" :active="$route.hash === '#usergardesh'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#usergardesh'
          )
          " title="تراکنش ها">
          <!-- <div class="col-md-4">
          <b-form-group label="درگاه">
            <b-form-select :options="gateways" v-model="gid"> </b-form-select>
          </b-form-group>
        </div> -->

          <b-card-text>
            <list-table :url="turnovers.url" title="لیست گردش حساب" :fields="turnovers.fields"
              :params="turnovers.params" :detailCallFun="turnovers.detailCallFun"
              :detailCallFunType="turnovers.detailCallFunType" @handle_function_call="ShowDetail"></list-table>
          </b-card-text>
        </b-tab>

        <b-tab href="#settelmentsheba" :active="$route.hash === '#settelmentsheba'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#settelmentsheba'
          )
          " title="شماره شبا تسویه">
          <b-card-text>
            <list-table :url="settelmentsheba.url" title="لیست شباهای تسویه" :fields="settelmentsheba.fields"
              :params="settelmentsheba.params"></list-table>
          </b-card-text>
        </b-tab>

        <b-tab href="#ticketsend" :active="$route.hash === '#ticketsend'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#ticketsend'
          )
          " title="ارسال تیکت">
          <b-card-text>
            <b-alert :show="errors.length > 0" variant="danger">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-form>
              <b-form-group id="des-gr" label="پاسخ های آماده:" label-for="des">
                <MDDropdown v-bind:group="120" @input="change"></MDDropdown>
              </b-form-group>
              <b-form-group id="input-group-1" label="موضوع تیکت *: " label-for="input-1">
                <b-form-input id="input-1" required v-model="Ticket.subject" placeholder="عنوان تیکت "></b-form-input>
              </b-form-group>

              <div>
                <b-row>
                  <b-col>
                    <b-form-group id="des-gr" label="اهمیت:" label-for="des">
                      <MDDropdown v-bind:group="2" v-model="Ticket.mdid2_periority"></MDDropdown>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-group-3" label="دپارتمان: " label-for="input-3">
                      <b-form-select id="input-3" v-model="Ticket.department_id"
                        :options="department_options"></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-form-group id="input-group-4" label="متن تیکت: " label-for="input-4">
                  <b-form-textarea id="input-4" v-model="Ticket.text" placeholder="متن تیکت را اینجا تایپ کنید"
                    rows="8"></b-form-textarea>
                </b-form-group>
              </div>
              <div class="row">
                <div class="col-md-3 mt-3" v-for="(x, index) in Ticket.files" v-bind:key="x.file_id">
                  <!-- <b-img :src="x.fileUrl" fluid></b-img> -->
                  <b-button class="mr-5" @click="delete_attachment(index)" size="sm">
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                  <a target="_blank" :href="x.fileUrl">پیوست شماره {{ index + 1 }}</a>
                </div>
              </div>
              <div class="mt-3">
                <b-col cols="4">
                  <div>
                    <b-form-group id="input-group-4" label="اضافه کردن پیوست: " label-for="input-4">
                      <fileUploader v-model="file" v-bind:fileUploaded="fileUploaded"></fileUploader>
                    </b-form-group>
                  </div>
                </b-col>
              </div>
              <b-row class="mt-3">
                <b-col>
                  <b-button class="mr-3" variant="success" @click="submitTicket">ثبت تیکت</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-text>
        </b-tab>
        <b-tab title="تغییرات کاربر" href="#requestUserChanges" @click="getRequestUserDataChanges()">
          <b-card-text>
            <list-table :url="requestUserChanges.url" title="نمایش تغییرات کاربر" :fields="requestUserChanges.fields"
              :params="params">
            </list-table>
          </b-card-text>
        </b-tab>
        <b-tab title="شارژ دستی ریفاند" href="#requestUserCharge" :active="$route.hash === '#requestUserCharge'" @click="
          $router.push(
            '/' + $route.name + '/' + $route.params.id + '#requestUserCharge'
          )
          ">
          <b-card>
            <b-row>
              <b-col cols="12" sm="6" md="6">
                <b-form-group label="مبلغ(ریال):">
                  <NumberSeprator v-model="ManualCharge.amount"></NumberSeprator>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="6">
                <b-form-group label="کد رهگیری:">
                  <b-form-input v-model="ManualCharge.tracking_number"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="6">
                <b-form-group label="بانک:">
                  <b-form-select v-model="ManualCharge.bank" :options="loadedBankList"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="">
              <b-col>
                <b-button block variant="success" @click="RefundManualCharge">شارژ دستی ریفاند
                  <b-spinner style="width: 1.5rem; height: 1.5rem" v-if="isBusyManualCharge"
                    variant="light"></b-spinner>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-modal id="transaction-details" hide-footer>
      <template v-slot:modal-title>اطلاعات تراکنش</template>
      <div class="d-block">
        <b-form-group label="وضعیت:">
          <div class="form-control">
            {{ trDetail.is_verify == 1 ? "تایید شده" : "تایید نشده" }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ:">
          <div class="form-control">
            {{ Number(trDetail.cost).toLocaleString() }}
          </div>
        </b-form-group>
        <b-form-group label="تاریخ:">
          <div class="form-control">{{ trDetail.persian_date }}</div>
        </b-form-group>
        <b-form-group label="ساعت:">
          <div class="form-control">
            {{
              new Date(trDetail.verify_date).getHours() +
              ":" +
              new Date(trDetail.verify_date).getMinutes()
            }}
          </div>
        </b-form-group>
        <b-form-group label="آدرس درخواست دهنده:">
          <div class="form-control">
            <b-img :src="'media/svg/flags/' +
              trDetail.location.countryCode.toLowerCase() +
              '.svg'
              " height="20px"></b-img>
            {{ trDetail.ip }}
          </div>
        </b-form-group>
        <b-form-group label="کد رهگیری پرداخت:">
          <div class="form-control">{{ trDetail.sale_reference_id }}</div>
        </b-form-group>
        <b-form-group label="شماره کارت:">
          <div class="form-control sc-card-pan">
            {{ trDetail.card_holder_pan }}
          </div>
        </b-form-group>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('transaction-details')">بستن</b-button>
    </b-modal>
  </div>
</template>
<style>
.sc-card-pan {
  direction: ltr;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_ROLES } from "@/core/services/store/getRoles.module";
import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";
import { REFUND_MANUAL_CHARGE } from "@/core/services/store/refundManualCharge.module";
import TableShowData from "../../components/table";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import PersonInfo from "../Users/PersonInfo";
import CompanyInfo from "../Users/CompanyInfo";
import UserAddress from "../Users/UserAddress";
import fileUploader from "../../components/fileUploader";
import NumberSeprator from "../../components/numberSeprator";
import routesMap from '@/helpers/routesMap'
export default {
  name: "ClientDetails",
  data() {
    return {
      isBusyManualCharge: false,
      ManualCharge: {
        bank: null,
        amount: null,
        tracking_number: null,
      },
      OptionRoles: [],
      errors: [],
      department_options: [],
      file: "",
      Ticket: {
        subject: "",
        department_id: 2,
        mdid2_periority: 6,
        text: "",
        mdid1_status: 1,
        files: [],
        user_id: null,
      },
      user: {},
      trDetail: { location: { countryCode: "IR" } },
      errors: [],
      gateways: [],
      tickets: {
        url: "tickets?user_id=" + this.$route.params.id,
        newUrl: "ClientDetails/" + this.$route.params.id + "#ticketsend",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "subject",
            label: "عنوان",
          },
          {
            key: "ticket_periority.title",
            label: "اهمیت",
          },
          {
            key: "created_at",
            label: "تاریخ",
            formatter: (value, key, item) => {
              return persianDate.getDate(value);
            },
          },
          {
            key: "ticket_status.title",
            label: "وضعیت",
          },
          {
            key: "ticket_departments.name",
            label: "دپارتمان",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "عنوان",
            field: "subject",
            type: "text",
          },
          {
            label: "شناسه تیکت",
            field: "id_t",
            type: "text",
          },
          {
            label: "از تاریخ",
            field: "start_date",
            type: "date-picker",
          },
          {
            label: "تا تاریخ",
            field: "end_date",
            type: "date-picker",
          },
          {
            label: "دپارتمان",
            field: "department_id",
            type: "select",
            options: [],
          },
          {
            label: "وضعیت",
            field: "mdid1_status",
            type: "mddropdown",
            group: 1,
          },
        ],
        detailUrl: "ticketDetails",
      },
      settelmentsheba: {
        url: "settelmentsheba?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "nickname",
            label: "نام مالک",
          },
          {
            key: "shaba_number",
            label: "شماره شبا",
          },
          {
            key: "account_number",
            label: "شماره حساب",
          },

          {
            key: "bank_name.title",
            label: "نام بانک",
          },
          {
            key: "status.title",
            label: "وضعیت",
          },
        ],
        params: [],
      },
      merchats: {
        url: "paymentgateways?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نام وبسایت",
            field: "website_name",
            type: "text",
          },
        ],
        detailUrl: "editGateway",
      },
      transactions: {
        url: "transactions?user_id=" + this.$route.params.id,
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        fields: [
          {
            key: "id",
            label: "شماره تراکنش",
          },
          {
            key: "website_name",
            label: "وبسایت",
          },
          {
            key: "persian_date",
            label: "تاریخ تراکنش",
          },
          {
            key: "is_verify",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value ? "پرادخت شده" : "پرداخت نشده";
            },
            tdClass: (value, key, item) => {
              return value ? "text-success" : "text-danger";
            },
          },
          {
            key: "sale_reference_id",
            label: "کد رهگیری",
          },
          {
            key: "cost",
            label: "مبلغ",
          },
          {
            key: "card_holder_pan",
            label: "شماره کارت",
            tdClass: "sc-card-pan",
          },
          {
            key: "title",
            label: "نام بانک",
          },
          {
            key: "verify_date",
            label: "تاریخ و ساعت تایید",
            formatter: (value, key, item) => {
              return persianDate.getDateByFormat(value);
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "از تاریخ",
            field: "dateFrom",
            type: "date-picker",
          },
          {
            label: "تا تاریخ",
            field: "dateTo",
            type: "date-picker",
          },
          {
            label: "کد رهگیری پرداخت",
            field: "saleOrderId",
            type: "text",
          },
          {
            label: "چهار رقم آخر کارت",
            field: "cardNumber",
            type: "text",
          },
        ],
      },
      turnovers: {
        url: "GardeshHesab?user_id=" + this.$route.params.id,
        detailCallFun: "ShowDetail",
        detailCallFunType: "transaction_id",

        fields: [
          {
            label: "کد تراکنش",
            key: "transaction_id",
            formatter: (value, key, item) => {
              return value == null ? item.doc_id : value;
            },
          },
          {
            label: "عنوان تراکنش",
            key: "des",
            formatter: (value, key, item) => {
              return item.doc_id <= 0
                ? "تراکنش ناموفق"
                : item.ttalWithoutKarmozd >= 0
                  ? "واریز"
                  : "برداشت";
            },
          },
          {
            label: "تاریخ",
            key: "created_at",
            formatter: (value, key, item) => {
              var d = new Date(value);
              return (
                persianDate.getDateByFormat(value) +
                " " +
                d.getHours() +
                ":" +
                d.getMinutes()
              );
            },
          },
          {
            label: "مبلغ با احتساب کارمزد",
            key: "ttalWithoutKarmozd",
            formatter: (value, key, item) => {
              ///var mezrab = item.bes - item.bed > 0 ? 1 : -1;
              //return Number(mezrab * (item.bes - item.bed)).toLocaleString();
              return Number(value).toLocaleString();
            },
            tdClass: (value, key, item) => {
              return item.doc_id <= 0
                ? "text-warning"
                : item.ttalWithoutKarmozd > 0
                  ? "text-success"
                  : "text-danger";
            },
          },
          {
            label: "کارمزد",
            key: "karmozd",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          {
            label: "موجودی",
            key: "Total",
            formatter: (value, key, item) => {
              return item.doc_id <= 0
                ? "-----"
                : Number(value).toLocaleString();
            },
          },
          {
            label: "جزییات",
            key: "details",
          },
        ],
        params: [
          {
            label: "درگاه ها",
            field: "api",
            type: "select",
            options: [],
          },
        ],
      },
      userconf: {
        url: "userconf?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "type.title",
            label: "برای",
          },
          {
            key: "status.title",
            label: "وضعیت",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [],
        detailUrl: "editUserConf",
      },
      requestUserChanges: {
        url: "",
        fields: [
          {
            key: "from",
            label: "از",
          },
          {
            key: "to",
            label: "به",
          },
          {
            key: "type",
            label: "نوع",
          },
          {
            key: "date",
            label: "تاریخ",
            formatter: (value, key, item) => {
              return persianDate.getDate(value);
            },
          },
        ],
      },
      params: [],
      isBusy: false,
      routesMap,
    };
  },
  components: {
    "list-table": TableShowData,
    MDDropdown,
    PersonInfo,
    CompanyInfo,
    UserAddress,
    fileUploader,
    NumberSeprator,
  },
  computed: {
    loadedRoleList() {
      return this.$store.getters.loadedRoleList;
    },
    loadedBankList() {
      return this.$store.getters.loadedBankList;
    },
  },
  created() {
    httpHelper.setAuth();
    this.Getdepartment();
    this.Getgateway();
  },
  watch: {
    file: async function (newVal, oldVal) {
      this.Ticket.files.push({ file_id: newVal });
      this.Ticket.files.forEach(async (file, index) => {
        const imageUrl = await httpHelper.getImage(file.file_id);
        this.$set(this.Ticket.files[index], 'fileUrl', imageUrl.result.url || '');
      });
      this.newVal = '';
    },
  },
  methods: {
    Getdepartment() {
      httpHelper
        .getData("departments")
        .then((response) => {
          this.department_options = response.result.map((item) => {
            return { value: item.id, text: item.name };
          });
        })
        .catch((error) => { })
        .finally(() => {
          this.tickets.params[4].options = this.department_options;
        });
    },
    Getgateway() {
      httpHelper
        .getData("paymentgateways?user_id=" + this.$route.params.id + "&p=1")
        .then((response) => {
          this.gateways_options = response.result.map((item) => {
            return { value: item.id, text: item.website_name };
          });
        })
        .catch((error) => { })
        .finally(() => {
          this.turnovers.params[0].options = this.gateways_options;
        });
    },
    SaveUser() {
      this.errors = [];
      this.isBusy = true;
      httpHelper.postData("users", this.user).then((res) => {
        this.isBusy = false;
        if (res.success) {
          this.$makeToast(
            "success",
            "ذخیره موفق",
            "اطلاعات با موفقیت ذخیره گردید.",
            5000
          );
        }
      });
    },
    InquiryNationalcard() {
      this.errors = [];
      httpHelper
        .getData("users/inquirynationalcard/" + this.user.id)
        .then((res1) => {
          if (res1.error.length) {
            this.errors.push(res1.error[0]);
          }
          httpHelper
            .getData("users?id=" + this.$route.params.id)
            .then((res) => {
              this.user = res.result;
              if (this.user.created_at != null) {
                this.user.created_at = persianDate.getDateByFormat(
                  this.user.created_at
                );
              } else {
                this.user.created_at = "-";
              }
            });
        });
    },
    ShowDetail(item, type) {
      url = "";
      if (type == "id" && item.id != null) {
        var url = "transactions?id=" + item.id;
      }
      if (type == "transaction_id" && item.transaction_id != null) {
        var url = "transactions?id=" + item.transaction_id;
      }
      if (url != "") {
        httpHelper.getData(url).then((res) => {
          this.trDetail = res.result;
          this.$bvModal.show("transaction-details");
        });
      }
    },
    fileUploaded: async function () {
      this.Ticket.files.push({ file_id: this.file });
      this.Ticket.files.forEach(async (file, index) => {
        const imageUrl = await httpHelper.getImage(file.file_id);
        this.$set(this.Ticket.files[index], 'fileUrl', imageUrl.result.url || '');
      });
      this.file = '';
    },

    submitTicket: function () {
      this.errors = [];
      this.Ticket.user_id = this.$route.params.id;
      httpHelper
        .postData("tickets", this.Ticket)
        .then((response) => {
          if (response.success) {
            // this.$makeToast('success','ذخیره موفق',"اطلاعات با موفقیت ذخیره گردید.",5000)
            this.$router.push(`/ticketDetails/${response.result}`)
          } else {
            for (const key in response.error) {
              if (response.error.hasOwnProperty(key)) {
                const element = response.error[key];
                element.forEach((er) => {
                  this.errors.push(er);
                });
              }
            }
          }
        })
        .catch((error) => { })
        .finally(() => { });
    },
    delete_attachment(index) {
      this.Ticket.files.splice(index, 1);
    },
    LoadGateways() {
      httpHelper
        .getData("paymentgateways?p=not&user_id=" + this.$route.params.id)
        .then((response) => {
          this.gateways = response.result.map(function (o) {
            return {
              text: o.website_name,
              value: o.id,
            };
          });
        });
    },
    getRequestUserDataChanges() {
      this.requestUserChanges.url = `user-log/${this.$route.params.id}`;
    },
    getRoles() {
      this.$store.dispatch(GET_ROLES, "role");
    },
    change(e) {
      Object.assign(this.Ticket, {
        subject: e[0].text,
        text: e[0].description,
      });
    },
    RefundManualCharge() {
      this.isBusyManualCharge = true;
      const {
        ManualCharge,
        $route: {
          params: { id: user_id },
        },
      } = this;
      const payload = { ...ManualCharge, user_id };
      this.$store
        .dispatch(REFUND_MANUAL_CHARGE, payload)
        .then((data) => {
          if (data.success) {
            const keys = Object.keys(this.ManualCharge);
            keys.forEach((key) => {
              this.ManualCharge[key] = null;
            });
            this.$makeToast(
              "success",
              "شارژ موفق",
              "عملیات  شارژ با موفقیت انجام گردید.",
              5000
            );
          } else {
            this.$makeToast(
              "danger",
              "خطا",
              "خطای سمت سرور رخ داده است.",
              7000
            );
          }
        })
        .catch((error) => {
          this.$makeToast("danger", "خطا", "خطای سمت سرور رخ داده است.", 7000);
        })
        .finally(() => (this.isBusyManualCharge = false));
    },
    getBankList() {
      this.$store.dispatch(GET_BANK_LIST);
    },
  },
  mounted() {
    httpHelper.getData("users?id=" + this.$route.params.id).then((res) => {
      this.user = res.result;
      if (this.user.created_at != null) {
        this.user.created_at = persianDate.getDateByFormat(
          this.user.created_at
        );
      } else {
        this.user.created_at = "-";
      }
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست مشترکین",
        route: "/clients",
      },
      {
        title: "ویرایش مشترکین",
      },
    ]);
    this.getRoles();
    this.$route.query.from === "unConfirm"
      ? this.$makeToast(
        "success",
        "بروزرسانی موفق",
        "عملیات عدم تایید با موفقیت انجام گردید.",
        5000
      )
      : this.$route.query.from === "Confirm"
        ? this.$makeToast(
          "success",
          "بروزرسانی موفق",
          "عملیات  تایید با موفقیت انجام گردید.",
          5000
        )
        : "";
    this.getBankList();
  },
};
</script>
